import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import moment from 'moment';
import { KeyUri, config } from '../key'
import axios from 'axios';
import { createReview, fetchReviews, reviewSelector } from '../api/userReview';
import { useDispatch, useSelector } from 'react-redux';

const Booking = () => {
    const navigate = useNavigate();
    const { reviews } = useSelector(reviewSelector)
    const location = useLocation();
    const { order } = location.state || {};
    const [stars, setStars] = useState(0);
    const [comment, setComment] = useState("");
    const dispatch = useDispatch();
    const rideId = order?._id
const token = JSON.parse(localStorage.getItem("tokenUser"));
    // Date formatting functions
    const formatDate = (dateString) => moment(dateString).format("DD MMM YYYY");
    const formatDateTime = (dateString) => moment(dateString).format("DD MMM YYYY, hh:mm A");
const [currentOrder, setCurrentOrder] = useState(order);

    // Calculate cancellation availability
    const canCancel = () => {
        if (!currentOrder?.ride_date_and_time || currentOrder.status === "Cancellation Requested") return false;

        const rideDateTime = moment.utc(currentOrder.ride_date_and_time);
        const cancellationDeadline = rideDateTime.clone().subtract(48, 'hours');
        const currentTime = moment.utc();

        return currentTime.isBefore(cancellationDeadline);
        //return true;
    };
   


  const cancel = async () => {
    alert("Booking is Ready To Cancel");
    try {
      const cancelbooking = await axios.post(
        `${KeyUri.BACKEND_URI}/payment/cancel-booking/`,
        {
          bookingId: currentOrder?._id,
          paymentId: currentOrder?.payment_id,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const removeintrip = await axios.post(
        `${KeyUri.BACKEND_URI}/update-seat-availability`,
        { bookingId: currentOrder?._id },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

        

     
      setCurrentOrder((prev) => ({
        ...prev,
        status: "Cancellation Requested",
      }));
    } catch (err) {
      console.error(err);
      console.error("Cancel booking error:", err.response || err);
      alert("Failed to cancel booking. Please try again.");
    }
  };


    useEffect(() => {
        dispatch(fetchReviews(rideId))
    }, [rideId])


    const handleSubmit = (e) => {
        e.preventDefault();

        if (stars === 0) {
            alert("Please select a star rating.");
            return;
        }

        const reviewData = { stars, comment, rideId };

        dispatch(createReview(reviewData));

        setStars(0);
        setComment("");
        setTimeout(() => {

            dispatch(fetchReviews(rideId))
        }, 500)
    };


    if (!order) return <div className="mt-40 text-center">No booking details found</div>;



    return (
        <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 font-lato">
             <div className="p-4 max-w-xl mr-80">
         <button
        onClick={() => navigate(-1)}
        className="text-gray-600 hover:text-gray-800 hidden md:block mt-[3.5rem] mr-100"
      >
        ← Go Back
      </button>
      </div> 
            <div className="max-w-4xl mx-auto md:mt-18 bg-white rounded-lg shadow-md p-8">
                {/* Header Section */}
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center border-b pb-4 mb-6 gap-4">
                    <div>
                        <h1 className="text-xl font-bold text-gray-800">
                            Booking ID: {currentOrder.booking_id}
                        </h1>
                        {/* <p className="text-gray-600 mt-1">
                            Status: <span className={`font-semibold ${order.status === "Cancelled" ? "text-red-600" : "text-green-600"}`}>
                                {order.status}
                            </span>
                        </p> */}
                    </div>

                    {currentOrder.status !== "Cancelled" && (
                        <div className="w-full sm:w-auto">
                            {currentOrder.status === "Cancelled" && (
                                <p className="text-red-500 text-sm">Booking has been cancelled</p>
                            )}
                            {currentOrder.status === "Cancellation Requested" && (
                                <p className="text-yellow-500 text-sm">
                                    Cancellation is in progress...
                                </p>
                            )}
                            {currentOrder.status === "Ride Started" && (
                                <p className="text-blue-500 text-sm">
                                    Ride is in progress. Cannot cancel now.
                                </p>
                            )}
                            {currentOrder.status === "Ride Completed" && (
                                <p className="text-green-500 text-sm">
                                    Ride has been completed. Cancellation not possible.
                                </p>
                            )}
                            {/* Allow Cancellation Only If Ride Hasn't Started */}
                            {(currentOrder.status === "Not Started" || currentOrder.status === "Pending") && (
                                <>
                                    {canCancel() ? (
                                        <button
                                            className="bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded-lg transition-colors w-full sm:w-auto"
                                            onClick={cancel}
                                        >
                                            Cancel Booking
                                        </button>
                                    ) : (
                                        <div className="text-right">
                                            <p className="text-gray-500 text-sm">
                                                Cancellation unavailable
                                            </p>
                                            {currentOrder.ride_date_and_time && (
                                                <p className="text-gray-400 text-xs">
                                                    Deadline was{" "}
                                                    {formatDateTime(
                                                        moment
                                                            .utc(order.ride_date_and_time)
                                                            .subtract(48, "hours")
                                                            .format()
                                                    )}
                                                </p>
                                            )}
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    )}
                </div>

                {/* Booking Details Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Driver & Vehicle Section */}
                    <div className="border rounded-lg p-4">
                        <h2 className="text-lg font-semibold mb-4">Driver & Vehicle Details</h2>
                        <div className="space-y-2">
                            <p><span className="font-medium">Driver Name:</span> {currentOrder.driverId?.name}</p>
                            <p><span className="font-medium">Contact:</span> {currentOrder.driverId?.phone_number}</p>
                            <p><span className="font-medium">Vehicle ID:</span> {currentOrder.vehicleId?.reg_no}</p>
                            <p><span className="font-medium">License Number:</span> {order.driverId?.Driver_licence_number}</p>
                        </div>
                    </div>

                    {/* Route Information */}
                    <div className="border rounded-lg p-4">
                        <h2 className="text-lg font-semibold mb-4">Route Information</h2>
                        <div className="space-y-2">
                            <p><span className="font-medium">From:</span> {order.route?.from_location?.name}</p>
                            <p><span className="font-medium">To:</span> {order.route?.to_location?.name}</p>
                            <p><span className="font-medium">Distance:</span> {order.route?.no_of_kms} km</p>
                            <p><span className="font-medium">Route ID:</span> {order.route?.route_id}</p>
                        </div>
                    </div>

                    {/* Pickup & Drop Section */}
                    <div className="border rounded-lg p-4">
                        <h2 className="text-lg font-semibold mb-4">Pickup & Drop Points</h2>
                        <div className="space-y-2">
                            <p><span className="font-medium">Pickup Point:</span> {order.pickup_point}</p>
                            <p><span className="font-medium">Drop Point:</span> {order.drop_point}</p>
                            <p><span className="font-medium">Ride Date:</span> {formatDate(order.ride_date_and_time)}</p>
                            <p><span className="font-medium">Scheduled Time:</span> {formatDateTime(order.ride_date_and_time)}</p>
                        </div>
                    </div>

                    {/* Passenger Details */}
                    <div className="border rounded-lg p-4">
                        <h2 className="text-lg font-semibold mb-4">Passenger Details</h2>
                        <div className="space-y-2">
                            <p><span className="font-medium">Selected Seats:</span> {order.selected_seats?.join(', ')}</p>
                            <p><span className="font-medium">Booking Date:</span> {formatDateTime(order.createdAt)}</p>
                            <p><span className="font-medium">User ID:</span> {order.userid}</p>
                        </div>
                    </div>

                    {/* Payment Details */}
                    <div className="border rounded-lg p-4 col-span-full">
                        <h2 className="text-lg font-semibold mb-4">Payment Information</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <p><span className="font-medium">Amount:</span> ₹{order.payment_amount?.toFixed(2)}</p>
                                <p><span className="font-medium">Payment Method:</span> {order.payment_method?.toUpperCase()}</p>
                                <p><span className="font-medium">Payment ID:</span> {order.payment_id}</p>
                            </div>
                            <div>
                                <p><span className="font-medium">Payment Status:</span>
                                    <span className={`ml-2 px-2 py-1 rounded ${order.payment_status === 'captured' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                                        {order.payment_status}
                                    </span>
                                </p>
                                <p><span className="font-medium">Payment Date:</span> {formatDateTime(order.payment_date)}</p>
                                <p><span className="font-medium">Booking Date:</span> {formatDate(order.date)}</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Additional Information */}
                <div className="mt-6 text-sm text-gray-500 space-y-1">
                    <p>Booking created at: {formatDateTime(order.createdAt)}</p>
                    <p>Last updated at: {formatDateTime(order.updatedAt)}</p>
                </div>

                {/* Cancellation Policy Notice */}
                {currentOrder.status !== "Cancelled" && (
                    <div className="mt-6 p-4 bg-yellow-50 rounded-lg">
                        <p className="text-sm text-yellow-700">
                            ⓘ Cancellation is available up to 48 hours before the ride start time.
                            {currentOrder.ride_date_and_time && (
                                <>
                                    After {formatDateTime(moment.utc(order.ride_date_and_time).subtract(48, 'hours').format())},
                                    cancellations will no longer be permitted.
                                </>
                            )}
                        </p>
                       

                    </div>
                )}
                {order?.status === "Ride Completed" && (
                    <div className="max-w-md mx-auto bg-white shadow-lg rounded-lg p-6">
                        <h2 className="text-xl font-bold mb-4 text-gray-800">
                            {reviews && reviews.length > 0 ? "Your Review" : "Leave a Review"}
                        </h2>

                        {/* If Review Exists, Show It */}
                        {reviews && reviews.length > 0 ? (
                            <div>
                                <div className="flex space-x-1 mb-4">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <span
                                            key={star}
                                            className={`text-2xl ${star <= reviews[0]?.stars ? "text-yellow-400" : "text-gray-300"}`}
                                        >
                                            ★
                                        </span>
                                    ))}
                                </div>
                                {reviews[0]?.comment && (
                                    <p className="text-gray-700 border border-gray-300 p-3 rounded-lg">
                                        {reviews[0]?.comment}
                                    </p>
                                )}
                            </div>
                        ) : (
                            /* If No Review, Show Form */
                            <div>
                                {/* Star Selection */}
                                <div className="flex space-x-1 mb-4">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <button
                                            key={star}
                                            onClick={() => setStars(star)}
                                            className={`text-2xl ${star <= stars ? "text-yellow-400" : "text-gray-300"}`}
                                        >
                                            ★
                                        </button>
                                    ))}
                                </div>

                                {/* Comment Input */}
                                <textarea
                                    value={comment}
                                    onChange={(e) => setComment(e.target.value)}
                                    placeholder="Write your review here..."
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                ></textarea>

                                {/* Submit Button */}
                                <button
                                    onClick={handleSubmit}
                                    className="w-full bg-blue-600 text-white py-2 mt-4 rounded-lg hover:bg-blue-700 transition duration-300"
                                >
                                    Submit Review
                                </button>
                            </div>
                        )}
                    </div>
                )}



            </div>
        </div>
    );
}

export default Booking;